import { store } from '@reduxLocal/persistState';

/** Stable scope id for React Query keys and offline queue partitioning. */
export const getSessionScopeIdFromStore = (): string => {
	const state = store.getState();
	const selectedProfile = state?.app?.selectedProfile;
	const companyId = selectedProfile?.id || selectedProfile?._id;
	if (companyId) return `company:${companyId}`;

	const userId = state?.promiseData?.data?.userData?.id;
	const targetUserId = state?.promiseData?.data?.userData?.targetUserId;
	if (targetUserId) return `user:${targetUserId}`;

	return `personal:${userId || 'unknown'}`;
};

export const buildSessionScopeId = (options: {
	companyId?: string | null;
	targetUserId?: string | null;
	userId?: string | null;
}): string => {
	if (options.companyId) return `company:${options.companyId}`;
	if (options.targetUserId) return `user:${options.targetUserId}`;
	return `personal:${options.userId || 'unknown'}`;
};
